var _rect, _rect2, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyJobBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3193_19274)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#063065"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.53,
    y: -866,
    width: 1200,
    height: 1200,
    rx: 100,
    transform: "rotate(45 1282.53 -866)",
    fill: "url(#paint0_linear_3193_19274)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3193_19274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 475,
    y: -825,
    width: 1615,
    height: 1615
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.53,
    y: -866,
    width: 1200,
    height: 1200,
    rx: 100,
    transform: "rotate(45 1282.53 -866)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3193_19274)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.215346
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 382.107,
    y: -767,
    width: 1000,
    height: 1000,
    rx: 100,
    transform: "rotate(45 382.107 -767)",
    fill: "url(#paint1_linear_3193_19274)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.158873
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.11,
    y: -961.214,
    width: 1000,
    height: 1000,
    rx: 100,
    transform: "rotate(45 1282.11 -961.214)",
    fill: "url(#paint2_linear_3193_19274)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3193_19274",
    x1: 1882.53,
    y1: -866,
    x2: 1882.53,
    y2: 334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3193_19274",
    x1: 882.107,
    y1: -767,
    x2: 882.107,
    y2: 233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3193_19274",
    x1: 1782.11,
    y1: -961.214,
    x2: 1782.11,
    y2: 38.7864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3193_19274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJobBackIcon);
export default __webpack_public_path__ + "static/media/MyJobBackIcon.3e4b022ede0cd3126f4d58b7e34ddbc9.svg";
export { ForwardRef as ReactComponent };